import ReactDOM from "react-dom/client"
import App from "./App"
import { markNativeShell } from "./lib/nativeShell"
import { startViewportLog } from "./lib/viewportLog"
import "./styles/main.css"

// Before the first render, so the shell's CSS is in place for the first paint.
markNativeShell()
// Geometry history for /admin/viewport; cheap, and only changes are kept.
startViewportLog()

ReactDOM.createRoot(document.getElementById("root")!).render(
  <App />
)
